import { create } from 'zustand';
import { SavedSearchMetadata } from './types';

interface SavedSearchMetadataStore {
  metadata: SavedSearchMetadata | null;
  setMetadata: (metadata: SavedSearchMetadata) => void;
}

export const useSavedSearchMetadataStore = create<SavedSearchMetadataStore>(
  (set) => ({
    metadata: null,
    setMetadata: (metadata) => set({ metadata }),
  })
);
